import { cart, Cart } from './cart'
import { cartAppliedCoupon, CartAppliedCoupon } from 'lib/core/services/magento/queries/cartAppliedCupon'
import { billingAddresses, BillingAddresses } from './cartBillingAddresses'
import { cartPrices, CartPrices } from './cartPrices'
import { cartQuery, CartQuery } from './cartQuery'
import { shippingAddresses, ShippingAddresses } from './cartShippingAddress'
import { cmsBlocksQueryObject, CmsBlocksQueryObject } from './cmsBlocks'
import { cmsPageQueryObject, CmsPageQueryObject } from 'lib/core/services/magento/queries/cmsPage'
import { countryQueryObject, CountryQueryObject } from 'lib/core/services/magento/queries/country'
import { countriesQueryObject, CountriesQueryObject } from 'lib/core/services/magento/queries/countries'
import { customer, CustomerQuery } from 'lib/core/services/magento/queries/customer'
import { customerOrdersQueryObject, CustomerOrdersQueryObject } from 'lib/core/services/magento/queries/customerOrders'
import { customerPaymentTokensQueryObject, CustomerPaymentTokensQueryObject } from 'lib/core/services/magento/queries/customerPaymentTokens'
import { getCategoryListQueryObject, GetCategoryListQueryObject } from 'lib/core/services/magento/queries/getCategoryList'
import { getCheckoutConfigQueryObject, GetCheckoutConfigQueryObject } from 'lib/core/services/magento/queries/getCheckoutConfig'
import { cmsPagesQueryObject, CmsPagesQueryObject } from './getCmsPages' // TODO: rename to getCmsPages
import { getProductAttributeListQueryObject, GetProductAttributeListQueryObject } from 'lib/core/services/magento/queries/getProductAttributeList'
import { postCategoriesQueryObject, PostCategoriesQueryObject } from 'lib/core/services/magento/queries/postCategories'
import { postsQueryObject, PostsQueryObject } from 'lib/core/services/magento/queries/posts'
import { productsQueryObject, ProductsQueryObject } from 'lib/core/services/magento/queries/products'
import { refreshCustomerTokenQueryObject, RefreshCustomerTokenQueryObject } from 'lib/core/services/magento/queries/refreshCustomerToken'
import { storeConfig, StoreConfig } from 'lib/core/services/magento/queries/storeConfig'
import { urlResolverQueryObject, UrlResolverQueryObject } from 'lib/core/services/magento/queries/urlResolver'
import { validateResetPasswordLinkTokenQueryObject, ValidateResetPasswordLinkTokenQueryObject } from 'lib/core/services/magento/queries/validateResetPasswordLinkToken'
import { visitureGetCartGiftMessageQueryObject, VisitureGetCartGiftMessageQueryObject } from './visitureGetCartGiftMessage'
import { visitureInstagramPostsQueryObject, VisitureInstagramPostsQueryObject } from './visitureInstagramPost'
import { visitureProductsQueryObject, VisitureProductsQueryObject } from 'lib/core/services/magento/queries/visitureProducts'
import { wishlistQueryObject, WishlistQueryObject } from 'lib/core/services/magento/queries/wishlist'
import { customerValidationQueryObject, CustomerValidationQuery } from 'lib/core/services/magento/queries/validateCustomer'

export interface Queries {
  cart: Cart
  cartAppliedCoupon: CartAppliedCoupon
  billingAddresses: BillingAddresses
  cartPrices: CartPrices
  cartQuery: CartQuery
  shippingAddresses: ShippingAddresses
  cmsBlocksQuery: CmsBlocksQueryObject
  cmsPageQuery: CmsPageQueryObject
  countriesQuery: CountriesQueryObject
  countryQuery: CountryQueryObject
  customerQuery: CustomerQuery
  customerOrdersQuery: CustomerOrdersQueryObject
  customerPaymentTokensQuery: CustomerPaymentTokensQueryObject
  getCategoryListQuery: GetCategoryListQueryObject
  getCheckoutConfigQuery: GetCheckoutConfigQueryObject
  getCmsPagesQuery: CmsPagesQueryObject
  getProductAttributeListQuery: GetProductAttributeListQueryObject
  postCategoriesQuery: PostCategoriesQueryObject
  postsQuery: PostsQueryObject
  productsQuery: ProductsQueryObject
  refreshCustomerTokenQuery: RefreshCustomerTokenQueryObject
  storeConfig: StoreConfig
  urlResolverQuery: UrlResolverQueryObject
  validateResetPasswordLinkTokenQuery: ValidateResetPasswordLinkTokenQueryObject
  visitureGetCartGiftMessageQuery: VisitureGetCartGiftMessageQueryObject
  visitureInstagramPostQuery: VisitureInstagramPostsQueryObject
  visitureProductsQuery: VisitureProductsQueryObject
  wishlistQuery: WishlistQueryObject
  customerValidationQuery: CustomerValidationQuery
}

export const _queries: Queries = {
  cart: { ...cart },
  cartAppliedCoupon: { ...cartAppliedCoupon },
  billingAddresses: { ...billingAddresses }, // TODO: rename to cartBillingAddress
  cartPrices: { ...cartPrices },
  cartQuery: { ...cartQuery },
  shippingAddresses: { ...shippingAddresses }, // TODO rename to cartShippingAddress
  cmsBlocksQuery: { ...cmsBlocksQueryObject },
  cmsPageQuery: { ...cmsPageQueryObject },
  countriesQuery: { ...countriesQueryObject },
  countryQuery: { ...countryQueryObject },
  customerQuery: { ...customer },
  customerOrdersQuery: { ...customerOrdersQueryObject },
  customerPaymentTokensQuery: { ...customerPaymentTokensQueryObject },
  getCategoryListQuery: { ...getCategoryListQueryObject },
  getCheckoutConfigQuery: { ...getCheckoutConfigQueryObject },
  getCmsPagesQuery: { ...cmsPagesQueryObject },
  getProductAttributeListQuery: { ...getProductAttributeListQueryObject },
  postCategoriesQuery: { ...postCategoriesQueryObject },
  postsQuery: { ...postsQueryObject },
  productsQuery: { ...productsQueryObject },
  refreshCustomerTokenQuery: { ...refreshCustomerTokenQueryObject },
  storeConfig: { ...storeConfig },
  urlResolverQuery: { ...urlResolverQueryObject },
  validateResetPasswordLinkTokenQuery: { ...validateResetPasswordLinkTokenQueryObject },
  visitureGetCartGiftMessageQuery: { ...visitureGetCartGiftMessageQueryObject },
  visitureInstagramPostQuery: { ...visitureInstagramPostsQueryObject },
  visitureProductsQuery: { ...visitureProductsQueryObject },
  wishlistQuery: { ...wishlistQueryObject },
  customerValidationQuery: { ...customerValidationQueryObject }
}
